export enum InputType {
  EMAIL = "email",
  NUMBER = "number",
  TEXT = "text",
  PASSWORD = "password",
  TEL = "tel"
}
